/* eslint-disable import/prefer-default-export */
import store from './store';

export const getCurrentState = () => {
  return store.getState();
};

export const dispatch = (reducerMethod) => {
  return store.dispatch(reducerMethod);
};

export const subscribe = (callback) => {
  return store.subscribe(callback);
};

export const observeStore = (observations) => {
  const unsubscribes = observations.map(({ select, onChange }) => {
    let currentState = select(store.getState());
    function handleChange() {
      const nextState = select(store.getState());
      if (nextState !== currentState) {
        currentState = nextState;
        onChange(currentState);
      }
    }

    const unsubscribe = store.subscribe(handleChange);
    handleChange();

    return unsubscribe;
  });

  return () => {
    unsubscribes.forEach((unsubscribe) => unsubscribe());
  };
};
